import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import React from "react";

function RecentConsultation({ consultations }) {
  const { handleProceedWithRecentConsult } = useConsultDoctorContext();

  return consultations.map((item) => (
    <button
      key={`${item.location}_${item.dateTime}`}
      className="w-full text-left p-3 border rounded-lg mb-2 text-sm"
      onClick={() => handleProceedWithRecentConsult(item)}
    >
      {item.location}
    </button>
  ));
}

export default RecentConsultation;
